import React, { useContext, useEffect, useState } from 'react'
import Header from '../../Components/Header'
import Footer from '../../Components/Footer'
import InstructorImage from '../../assets/fuad.jpeg'
import BadgeIcon from '@mui/icons-material/Badge';
import VerifiedIcon from '@mui/icons-material/Verified';
import InstructorCourses from './Components/InstructorCourses';
import { baseUrl, path } from '../../constants';
import { api } from '../../api';
import { useParams } from 'react-router-dom';
import CourseCard, { CourseCardSkeleton } from '../../Components/CourseCard'
import Preview from '../Landing/Components/Preview'
import { settingsContext } from '../../Context/settingsProvider';

export default function Instructor() {
    const {id} = useParams()
    const [instructor, setInstructor] = useState({})
    const [loading, setLoading] = useState(true)
    const [selectedCourse, setSelectedCourse] = useState(null)
    const {t} = useContext(settingsContext)

    useEffect(() => {
        api.get(path.instructor + '/' + id).then(response => {
            let data = response.data
            if(data.success){
                setInstructor(data.instructor)
            }
        }).finally(() => setLoading(false))
    }, [])

    return (
        <div className='w-full h-full flex flex-col bg-[#f2f2f2] pt-[60px]'>
            <Header withLogo />
            <div className='flex-1 p-5'>
                <div className='h-[180px] max-md:h-[80px] w-full bg-[#e2e2e2] relative rounded-md overflow-hidden'>
                    <img className='w-full h-full object-cover' src={baseUrl + instructor.cover} />
                </div>
                <div className='flex gap-4 mt-4'>
                    <div className='flex flex-col'>
                        <img src={baseUrl + instructor?.image} className='w-[150px] h-[150px] max-md:w-[100px] max-md:h-[100px] object-cover rounded-full border-[3px] border-main' />
                    </div>
                    <div className='flex flex-col gap-1 justify-center'>
                        <h1 className='text-[28px] max-md:text-[20px] max-md:tracking-wide font-bold tracking-wider'>{`${instructor?.sellerprofile?.name || ''}`}</h1>
                        <p className='font-bold text-sm max-md:text-xs py-1 px-2 bg-black text-white w-fit rounded-sm'>{instructor.userStatus == 4 ? 'Verified Institute' : 'Verified Instructor'}</p>
                        <p className='font-bold text-sm max-md:text-xs'>{instructor.courses?.length || 0} {t('COURSES')}</p>
                    </div>
                </div>
                <p className='mt-4 font-bold text-lg pl-2'>Courses</p>
                <div className='grid grid-cols-4 max-md:grid-cols-1 gap-x-4 gap-y-4 flex-1 mt-1'>
                    {!instructor.courses?.length && !loading && <p className='whitespace-nowrap opacity-75 text-sm pt-6'>No Courses are Available.</p>}
                    { loading ? new Array(4).fill(0).map(course => (
                            <CourseCardSkeleton />
                        )) : instructor.courses?.map(course => (
                            <CourseCard instructor course={course} setSelectedCourse={setSelectedCourse} />
                    ))}
                    {selectedCourse && <Preview setSelectedCourse={setSelectedCourse} selectedCourse={selectedCourse} /> }
                </div>
            </div>
            <Footer />
        </div>
    )
}
